/**
 * Headroom
 *
 * Configures the headroom script
 *
 * @author      Christopher Tousignant <christopher.tousignant@nichols.edu>
 * @package     NicholsCollege
 * @since       1.0.0
 * @version     1.0.0
 */

import Headroom from 'headroom.js';
import $ from 'jquery';
import './../abstracts/debounce.es6';

export default ( ( $ ) => {

    let header = $("header")[0];
    let headroom = new Headroom( header );
    let colophon = $("#colophon")[0];
    let footroom = new Headroom( colophon );

    if( headroom.elem )
    {
        headroom.init( { "offset" : 205, "tolerance" : 5 } );

        $(window).scroll( $.debounce( 30000, function(){
            if( $( 'body' ).hasClass( 'hamburg-closed' ) )
                headroom.pin();
        }));
    }

    if( footroom.elem )
    {
        footroom.init( { "offset" : 205, "tolerance" : 5 } );

        $(window).scroll( $.debounce( 30000, function(){
            if( $( 'body' ).hasClass( 'hamburg-closed' ) )
                footroom.pin();
        }));
    }

})( $.noConflict() );